import { SET_EMAIL_BUILDER_HMAC } from 'store/types';

const initialState = {
    hmac: null
}

export default function emailBuilder(store = initialState, { type, payload }) {
    switch (type) {
        case SET_EMAIL_BUILDER_HMAC:
            return {
                ...store, hmac: payload
            }
        default:
            return store;
    }
}